<div class="pt-3 pl-4 w-full">
  <span class="p-float-label">
    <input [pTooltip]="projectDescriptor.label" tooltipPosition="top"
      class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border rounded-border appearance-none outline-none focus:border-primary w-full"
      type="text" [id]="'pdText_'+descriptorCategory().uniqueId+'_'+projectDescriptor.uniqueId" pInputText [(ngModel)]="holder">
    <label [for]="'pdText_'+descriptorCategory().uniqueId+'_'+projectDescriptor.uniqueId"> {{projectDescriptor.label}} @if (projectDescriptor.help) {
      <i class="pi pi-question-circle" [pTooltip]="projectDescriptor.help" style="font-size: 1rem"></i>
    }</label>
  </span>
</div>
